<template>
  <input 
    class="special-value-item"
    :class="{'disabled': disabled}"
    type="text"
    placeholder="请填写"
    :value="modelValue"
    @input="onChange($event)"
    @click.stop
  />
</template>

<script>

export default {
  props: {
    modelValue: String,
    disabled: Boolean
  },
  emits: ['update:modelValue'],
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
    onChange(e) {
      this.$emit('update:modelValue', e.target.value);
    }
  },
  created() {},
  async mounted() {
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.special-value-item {
  .input-item();
  margin-top: 6px;
  margin-bottom: 2px;
}
</style>
